import { useContext, useEffect, useState } from '@wordpress/element';
import { select } from '@wordpress/data';
import Typography from '@componentsNew/Typography';
import { IoIosArrowForward } from 'react-icons/io';
import { MdMoreVert, MdOutlinePublic } from 'react-icons/md';
import EstruturaPostContext from '@pages/DicasOtimizacao/Context/EstruturaPostContext';

function PreVisualizacaoTemplate({ meta, nomeBlog, valorInputRadio }) {
  const [palavras, setPalavras] = useState([]);
  const [urlIcon, setUrlIcon] = useState('');
  const [thumbnailUrl, setThumbnailUrl] = useState('');
  const [dataPublicacao, setDataPublicacao] = useState('');

  const { estrutura, metadados } = useContext(EstruturaPostContext);

  useEffect(() => {
    if (estrutura.link_permanente) setPalavras(formatarString(estrutura.link_permanente.conteudo));
    if (metadados?.icone_url) setUrlIcon(metadados?.icone_url);
    if (metadados?.thumbnail_url && metadados.thumbnail_url !== 'no_value')
      setThumbnailUrl(metadados?.thumbnail_url);
  }, [estrutura, metadados]);

  const post = select('core/editor').getCurrentPost();

  useEffect(() => {
    if (post?.date) {
      const data = new Date(post?.date);
      const mes = data.toLocaleString('default', { month: 'short' });
      const dia = data.getDate();
      const ano = data.getFullYear();

      const dataFormatada = `${dia} de ${mes} de ${ano}`;

      setDataPublicacao(dataFormatada);
    }
  }, [post]);

  function formatarString(str) {
    const url = str
      .replace(/.*\/\//, '')
      .replace(/\//g, ' ')
      .trim();
    const urlFormatada = url.length <= 25 ? url : url.substring(0, 25) + '...';
    return urlFormatada.split(' ');
  }

  return (
    <div
      className={`flex mt-2 ${
        valorInputRadio == 'mobile' ? 'shadow-mobile px-3 py-4 rounded-xl' : 'overflow-x-auto w-5/6'
      } `}
    >
      <div className={`${valorInputRadio == 'desktop' && 'whitespace-nowrap'} `}>
        <div
          className={` ${valorInputRadio == 'mobile' && 'justify-between'} flex items-center mb-4`}
        >
          <div className="flex">
            <div className="flex items-center mr-2">
              {urlIcon === '' && <MdOutlinePublic className="w-6 h-6" />}
              {urlIcon !== '' && (
                <img src={urlIcon} alt={'Logotipo do Blog'} loading="lazy" className="w-6 h-6" />
              )}
            </div>
            <div>
              <div>
                <Typography className="text-[0.85em] font-normal" component="base">
                  {nomeBlog}
                </Typography>
              </div>

              <div>
                <Typography className="text-[0.78em] font-normal text-[#7D8286]" component="base">
                  {palavras.length > 0 &&
                    palavras.map((item, index) => {
                      return (
                        <span key={index} className="flex items-center">
                          {item}
                          {index < palavras.length - 1 && <IoIosArrowForward className="w-2 h-2" />}
                        </span>
                      );
                    })}
                </Typography>
              </div>
            </div>
          </div>

          <MdMoreVert className="w-6 h-6 cursor-pointer" />
        </div>

        <div className="flex gap-1 flex-col">
          <Typography className="text-[0.95em] text-[#1558D6] cursor-pointer" component="base">
            {meta?.tituloSeo}
          </Typography>

          <div className="flex justify-between items-start">
            <div className="text-[0.75em] text-[#AEB1B4]">
              {dataPublicacao} -&nbsp;
              <span className="text-text-primary">{meta?.metaDescription}</span>
            </div>

            {valorInputRadio == 'mobile' && thumbnailUrl !== '' && (
              <img
                src={thumbnailUrl}
                alt="Thambnail do post."
                className="ml-3 rounded-lg text-[0.7em] w-[6.313em]"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PreVisualizacaoTemplate;
